import { PaymentProviderEnum } from "../../shared/types/PaymentProviderEnum.ts";

export const useGetCurrencyFromPymentProvider = (paymentProvider: PaymentProviderEnum) => {
    switch (paymentProvider) {
        case PaymentProviderEnum.STARS:
            return "STR";
        case PaymentProviderEnum.YOOCASSA:
            return "RUB";
    }
};
